<template>
    <RejectedRequests></RejectedRequests>
</template>
<script>
    import RejectedRequests from '@/components/EmployeeRejectedRequests.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            RejectedRequests
        }
    }
</script>